import { FC, ReactNode, useContext } from 'react';
import { Divider } from '@robocorp/components';
import { styled } from '@robocorp/theme';

import { ListContext } from './List';

export interface ListHeadingProps {
  /**
   * @ignore
   */
  id?: string;
  /**
   * @ignore
   */
  className?: string;
  /**
   * Make list heading dense
   */
  dense?: boolean;
  /**
   * @ignore
   */
  children?: ReactNode;
}

/**
 * Link component
 */

const ListHeadingStyled = styled.h5<ListHeadingProps>`
  color: ${({ theme }) => theme.colors.grey20};
  font-size: ${({ theme }) => theme.fontSizes.$16};
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: ${({ dense }) => (dense ? '16px' : '20px')} ${({ dense }) => (dense ? '16px' : '20px')};
`;

const ListHeading: FC<ListHeadingProps> = ({ children, ...rest }) => {
  const { divider, dense } = useContext(ListContext);

  return (
    <>
      <ListHeadingStyled dense={dense} {...rest}>
        {children}
      </ListHeadingStyled>
      {divider && <Divider />}
    </>
  );
};

export default ListHeading;
